import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { isEmpty, includes, map } from 'lodash'

import { ReactComponent as IconCaret } from 'assets/icons/IconCaret.svg'

const DropdownSelect = (props) => {
  const {
    className,
    options,
    label,
    isDisabled,
    isEmptyOption,
    isValid,
    defaultValue,
    fullWidth,
    value,
    dark,
    ...rest
  } = props

  const isValueInOptions = includes(
    map(options, (option) => option.value),
    value
  )
  const checkedValue = isValueInOptions ? value : ''

  return (
    <div
      className={cn(['dropdown-select', className], {
        '-selected': !isEmpty(checkedValue) || !isEmpty(defaultValue),
        '-invalid': !isValid,
        '-full-width': fullWidth,
      })}
    >
      <select
        className={cn('dropdown-select__select', {
          '-dark': dark,
          '-has-value': !isEmpty(checkedValue),
        })}
        defaultValue={defaultValue}
        disabled={isDisabled}
        value={checkedValue || ''}
        {...rest}
      >
        {isEmptyOption && (
          <option disabled value="">
            Select option
          </option>
        )}
        {options.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label || item}
          </option>
        ))}
      </select>
      <span className="dropdown-select__arrow">
        <IconCaret className="dropdown-select__arrow-icon" />
      </span>
      <label
        className={cn('dropdown-select__label', {
          '-dark': dark,
        })}
      >
        {label}
      </label>
    </div>
  )
}

DropdownSelect.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isEmptyOption: PropTypes.bool,
  isValid: PropTypes.bool,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  fullWidth: PropTypes.bool,
  options: PropTypes.array.isRequired,
  dark: PropTypes.bool,
}

DropdownSelect.defaultProps = {
  isEmptyOption: false,
}

export default DropdownSelect
